import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

/* Cartao creme do guia (superficie elevada #FFF9EC, borda #E6DFD2, raio 20). */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return <div className={cn('rounded-card border border-line-soft bg-surface-warm shadow-card', className)} {...props} />
}

/* Selo em pilula (ex.: "Apadrinhamento desde 2023") */
export function Pill({ children, className, tone = 'brand', icon }: {
    children: ReactNode
    className?: string
    tone?: 'brand' | 'neutral' | 'action'
    icon?: ReactNode
}) {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold whitespace-nowrap',
                tone === 'brand' && 'bg-brand-soft text-brand-strong',
                tone === 'neutral' && 'bg-app-background text-ink-muted',
                tone === 'action' && 'bg-action text-ink uppercase tracking-[0.1em] text-[0.66rem]',
                className,
            )}
        >
            {icon}
            {children}
        </span>
    )
}

/* Circulo de icone (fundo verde claro, icone verde escuro por padrao) */
export function IconBadge({ children, className }: { children: ReactNode; className?: string }) {
    return (
        <span className={cn('flex size-10 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand-strong', className)}>
            {children}
        </span>
    )
}

/* Titulo de secao em Roboto Slab */
export function SectionTitle({ children, className, id, action }: { children: ReactNode; className?: string; id?: string; action?: ReactNode }) {
    return (
        <div className="flex items-baseline gap-2.5">
            <h2 id={id} className={cn('m-0 grow font-display text-[1.19rem] font-bold tracking-[-0.02em]', className)}>{children}</h2>
            {action}
        </div>
    )
}

/* Rotulo em caixa alta do guia (secoes de listas e configuracoes) */
export function SectionLabel({ children, id, className }: { children: ReactNode; id?: string; className?: string }) {
    return <h2 id={id} className={cn('label-caps m-0 text-ink-muted', className)}>{children}</h2>
}
